import { CardMedia } from "@mui/material";
import type { AssistantImage } from "../../../../api/types/assistantTypes";

interface Props {
  image: AssistantImage;
  onShow: (imageUrl: string) => void;
}

const ChatImage = ({ image, onShow }: Props) => (
  <CardMedia
    sx={{ width: 240, height: 160, borderRadius: 1, cursor: "pointer" }}
    image={image.url}
    title={image.title}
    onClick={() => onShow(image.url)}
  />
);

export default ChatImage;
